import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ResourceBar from "./ResourceBar";
import StatDetails from "./StatDetails";

function StatSheet(props) {
  return (
    <Row>
      <Col>
        <div> {props.character.name}</div>
        <ResourceBar
          type="health"
          curValue={props.character.hp.cur}
          maxValue={props.character.hp.max}
        />
        <ResourceBar
          type="mana"
          curValue={props.character.mp.cur}
          maxValue={props.character.mp.max}
        />
        <ResourceBar
          type="action"
          curValue={props.character.ap.cur}
          maxValue={props.character.ap.max}
        />
      </Col>
      <Col>
        <StatDetails character={props.character} />
      </Col>
    </Row>
  );
}

export default StatSheet;
